import { render, staticRenderFns } from "./RecursosOperacionaisDetalhePanel.vue?vue&type=template&id=c46fca42&scoped=true&"
import script from "./RecursosOperacionaisDetalhePanel.vue?vue&type=script&lang=js&"
export * from "./RecursosOperacionaisDetalhePanel.vue?vue&type=script&lang=js&"
import style0 from "./RecursosOperacionaisDetalhePanel.vue?vue&type=style&index=0&id=c46fca42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46fca42",
  null
  
)

export default component.exports